import React from 'react';
import { BrowserRouter as Router, Routes, Route, useLocation } from 'react-router-dom';
import { ThemeProvider } from '@mui/material/styles';
import { HelmetProvider } from 'react-helmet-async';
import CssBaseline from '@mui/material/CssBaseline';
import './i18n';
import theme from './styles/theme';
import './styles/global.css';

// Contextos
import { CityProvider } from './contexts/CityContext';

// Componentes
import Header from './components/Header';
import Footer from './components/Footer';

// Páginas
import Home from './pages/Home';
import SearchGyms from './pages/SearchGyms';
import Business from './pages/Business';
import Individual from './pages/Individual';
import Partners from './pages/Partners';
import PlansAndPrices from './pages/PlansAndPrices';
import Panel from './pages/panel';
import CheckInSimulator from './pages/CheckInSimulator';
import Terms from './pages/Terms';
import Privacy from './pages/Privacy';
import TestCheckins from './pages/TestCheckins';

// Layout wrapper component to handle conditional header/footer rendering
function AppLayout() {
  const location = useLocation();
  
  // More precise check for dashboard pages
  const isDashboardPage = () => {
    const path = location.pathname;
    return (path.startsWith('/panel/') || 
            path.includes('dashboard') || 
            path.includes('-dashboard'));
  };
  
  // Login page should show the regular header
  const isLoginPage = () => {
    return location.pathname === '/panel';
  };
  
  // Show header/footer only for public pages and login page
  const showMainLayout = !isDashboardPage() || isLoginPage();
  
  // Determine if we're in development mode
  const isDev = process.env.NODE_ENV === 'development' || 
                window.location.hostname === 'localhost' || 
                window.location.hostname.includes('127.0.0.1');
  
  return (
    <>
      {showMainLayout && <Header />}
      <main>
        <Routes>
          {/* Rutas públicas */}
          <Route path="/" element={<Home />} />
          <Route path="/search-gyms" element={<SearchGyms />} />
          <Route path="/business" element={<Business />} />
          <Route path="/individual" element={<Individual />} />
          <Route path="/partners" element={<Partners />} />
          <Route path="/plans-and-prices" element={<PlansAndPrices />} />
          <Route path="/check-in" element={<CheckInSimulator />} />
          <Route path="/terms" element={<Terms />} />
          <Route path="/privacy" element={<Privacy />} />
          
          {/* Rutas de desarrollo - solo disponibles en localhost */}
          {isDev && <Route path="/test-checkins" element={<TestCheckins />} />}
          
          {/* Rutas del panel de administración */}
          <Route path="/panel/*" element={<Panel />} />
        </Routes>
      </main>
      {showMainLayout && <Footer />}
    </>
  );
}

function App() {
  return (
    <HelmetProvider>
      <ThemeProvider theme={theme}>
        <CityProvider>
          <CssBaseline />
          <Router>
            <AppLayout />
          </Router>
        </CityProvider>
      </ThemeProvider>
    </HelmetProvider>
  );
}

export default App; 